import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-company',
  templateUrl: './icon-company.component.html',
  styleUrls: ['./icon-company.component.scss']
})
export class IconCompanyComponent implements OnInit {

  @Input() cssClass = '';
  
  constructor() { }

  ngOnInit() {
  }

}
